export const Dictionary = {
  __generic_api_failure: "Something went wrong.",
  __generic_api_error:
    "Cannot serve your request now. The remote server is unreachable.",
  __invalid_token:
    "Your request cannot be completed, the token is invalid. The security token may be expired or have already been used.",
  __generic_api_403: "You don't have permission to perform this action.",
  __you_are_offline: "You are not connected to internet.",
  __coming_soon:
    "This feature is currently under development and will be available soon.",
};
